import i18n from 'i18next';
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import initReactI18next from 'i18next';
import es from 'locales/es';
import en from 'locales/en';
import fr from 'locales/fr';

const resources = {
  es: {
    translation: es,
  },
  en: {
    translation: en,
  },
  fr: {
    translation: fr,
  },
};

const DETECTION_OPTIONS = {
  order: ['navigator'],
};

i18n.use(LanguageDetector).use(initReactI18next).init({
  detection: DETECTION_OPTIONS,
  resources,
  fallbackLng: 'en',
});
export default i18n;



// WEBPACK FOOTER //
// src/locales/i18n.js